import {
  Component,
  ComponentRef,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { StudentCoinService } from '@app/infrastructure/core/services/api/student-coin.service';
import { CoinSource } from '@app/infrastructure/models/coin';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';

@Component({
  template: `
    <div class="coin">
      <button class="coin-btn fade-in" (click)="handleBubblePopped()">
        <img
          #coinImg
          class="coin-img"
          src="assets/img/coin/bubble_coin.gif"
          alt="coin spinning"
        />
      </button>
    </div>
  `,
  selector: 'app-student-coin',
  styleUrls: ['./coin.component.scss'],
})
export class StudentCoinComponent implements OnInit, OnDestroy {
  @ViewChild('coinImg') imgRef: ElementRef<HTMLImageElement>;
  id: number;
  containerRef: ViewContainerRef;
  ref: ComponentRef<StudentCoinComponent>;
  saveCoin: boolean = true;
  x: number;
  y: number;
  stop: boolean = false;
  private animationReq: number;
  private isPopped: boolean = false;
  private bubblePopped$: Subject<void> = new Subject();
  private destroying$: Subject<void> = new Subject();
  constructor(private studentCoinService: StudentCoinService) {}

  ngOnInit(): void {
    this.startAnimationLoop();
    this.bubblePopped$
      .pipe(takeUntil(this.destroying$))
      .subscribe(() => this.popBubble());
  }

  ngOnDestroy() {
    this.destroying$.next();
  }

  handleBubblePopped(): void {
    if (this.isPopped) return;
    this.bubblePopped$.next();
  }

  popBubble(playSound: boolean = true): void {
    this.isPopped = true;
    if (playSound) {
      const audio = new Audio('assets/media/collect.wav');
      audio.play();
    }
    this.imgRef.nativeElement.src = 'assets/img/coin/bubble_pop_coin.gif';
    this.imgRef.nativeElement.classList.add('fade-out');
    this.stop = true;
    if (this.saveCoin) {
      this.studentCoinService
        .createCoin({
          amount: 1,
          coinSource: CoinSource.question,
        })
        .subscribe();
    }
    setTimeout(() => {
      this.imgRef.nativeElement.classList.add('faded');
      try {
        this.containerRef.remove(this.id);
      } catch (e) {
        this.containerRef.remove();
      }
    }, 2000);
  }

  private startAnimationLoop(): void {
    this.animationReq = requestAnimationFrame(this.tick.bind(this));
  }

  private tick() {
    if (this.stop) {
      cancelAnimationFrame(this.animationReq);
      return;
    }
    this.update();
    this.animationReq = requestAnimationFrame(this.tick.bind(this));
  }

  private update() {
    this.ref.location.nativeElement.style.top = this.y + 'px';
    this.ref.location.nativeElement.style.left = this.x + 'px';
    this.y -= 1;
    if (this.y < 0) {
      this.imgRef.nativeElement.src = 'assets/img/coin/bubble_pop_coin.gif';
      this.popBubble(false);
    }
  }
}
